let initialPaintComplete = false;
let resolveInitialPaint!: () => void;
const initialPaint = new Promise<void>((resolve) => {
  resolveInitialPaint = resolve;
});

export function afterInitialPaint(): Promise<void> {
  return initialPaintComplete ? Promise.resolve() : initialPaint;
}

export function markInitialPaintComplete(): void {
  if (initialPaintComplete) {
    return;
  }

  initialPaintComplete = true;
  resolveInitialPaint();
}
